module.exports = __webpack_public_path__ + "img/back-arrow.503058a3.svg";